<template>
  <div class="key-item" @click="openEdit">
    <p class="title">
      {{ item.title }}
    </p>
    <p class="content">
      {{ item.text }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'KeyItem',
  props: {
    item: {
      type: Object,
      require: true
    }
  },
  methods: {
    openEdit() {
      this.$emit('handleClick', this.item)
    }
  }
}
</script>

<style lang="less" scoped>
  .key-item {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: @primary-color;
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 6px;
    box-shadow: 0px 0px 4px 2px rgba(68, 208, 201, 0.2);
    padding: 0 10px;
    .title {
      font-size: 42px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .content {
      font-size: 36px;
    }
  }
</style>